import { render, staticRenderFns } from "./Step4Automations.vue?vue&type=template&id=3c24fdf7&scoped=true"
import script from "./Step4Automations.vue?vue&type=script&lang=js"
export * from "./Step4Automations.vue?vue&type=script&lang=js"
import style0 from "./Step4Automations.vue?vue&type=style&index=0&id=3c24fdf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c24fdf7",
  null
  
)

export default component.exports